export const initialDeviceConfigSchemasState = {
    schemasByDeviceId: {},
};
